import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "q-pa-md" };
const _hoisted_2 = { class: "text-h4 text-bold text-green-7" };
const _hoisted_3 = { class: "row q-pa-sm" };
const _hoisted_4 = {
    key: 0,
    class: "col-12 col-md-6"
};
const _hoisted_5 = { class: "q-pa-md" };
const _hoisted_6 = {
    key: 0,
    class: "table-caption"
};
const _hoisted_7 = {
    key: 1,
    class: "q-mb-lg entry-check-table"
};
const _hoisted_8 = { key: 0 };
const _hoisted_9 = { key: 1 };
const _hoisted_10 = { key: 2 };
const _hoisted_11 = {
    key: 2,
    class: "table-caption"
};
const _hoisted_12 = {
    key: 3,
    class: "q-mb-lg entry-check-table"
};
const _hoisted_13 = { class: "q-mb-lg entry-check-table" };
const _hoisted_14 = { class: "q-mb-lg entry-check-table" };
const _hoisted_15 = { key: 0 };
const _hoisted_16 = { key: 1 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_breadcrumb_list = _resolveComponent("breadcrumb-list");
    const _component_q_card_section = _resolveComponent("q-card-section");
    const _component_q_separator = _resolveComponent("q-separator");
    const _component_BukenRoomList = _resolveComponent("BukenRoomList");
    const _component_q_btn = _resolveComponent("q-btn");
    const _component_q_card_actions = _resolveComponent("q-card-actions");
    const _component_q_card = _resolveComponent("q-card");
    const _component_q_page = _resolveComponent("q-page");
    return (_openBlock(), _createBlock(_component_q_page, { class: "col column no-wrap" }, {
        default: _withCtx(() => [
            _createVNode(_component_breadcrumb_list, {
                breadCrumbs: [
                    { itemId: _ctx.PageID.top },
                    { itemId: _ctx.PageID.nyukyo }
                ]
            }, null, 8, ["breadCrumbs"]),
            _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_q_card, null, {
                    default: _withCtx(() => [
                        _createVNode(_component_q_card_section, { class: "bg-white" }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.pageName), 1)
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_q_separator),
                        _createVNode(_component_q_card_section, null, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_3, [
                                    (_ctx.myPageStore.isMultipleKeiyaku)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                            _createVNode(_component_BukenRoomList)
                                        ]))
                                        : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_5, [
                                    (!_ctx.isParking && !(_ctx.isLifeLineElectricity && _ctx.isLifeLineGas && _ctx.isLifeLineWater))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, "ライフライン連絡先（ご契約者様にてライフラインを契約されている場合は、ご契約会社へお問い合わせください）"))
                                        : _createCommentVNode("", true),
                                    (!_ctx.isParking && !(_ctx.isLifeLineElectricity && _ctx.isLifeLineGas && _ctx.isLifeLineWater))
                                        ? (_openBlock(), _createElementBlock("table", _hoisted_7, [
                                            _createElementVNode("tbody", null, [
                                                (!_ctx.isLifeLineElectricity)
                                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [
                                                        _cache[7] || (_cache[7] = _createElementVNode("th", null, "電気連絡先", -1)),
                                                        _createElementVNode("td", null, _toDisplayString(_ctx.nyukyo.lifeLineElectricity), 1)
                                                    ]))
                                                    : _createCommentVNode("", true),
                                                (!_ctx.isLifeLineGas)
                                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                                                        _cache[8] || (_cache[8] = _createElementVNode("th", null, "ガス連絡先", -1)),
                                                        _createElementVNode("td", null, _toDisplayString(_ctx.nyukyo.lifeLineGas), 1)
                                                    ]))
                                                    : _createCommentVNode("", true),
                                                (!_ctx.isLifeLineWater)
                                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                                                        _cache[9] || (_cache[9] = _createElementVNode("th", null, "水道連絡先", -1)),
                                                        _createElementVNode("td", null, _toDisplayString(_ctx.nyukyo.lifeLineWater), 1)
                                                    ]))
                                                    : _createCommentVNode("", true)
                                            ])
                                        ]))
                                        : _createCommentVNode("", true),
                                    (!_ctx.isParking && !_ctx.isPostDialNo)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, "設備情報"))
                                        : _createCommentVNode("", true),
                                    (!_ctx.isParking && !_ctx.isPostDialNo)
                                        ? (_openBlock(), _createElementBlock("table", _hoisted_12, [
                                            _createElementVNode("tbody", null, [
                                                _createElementVNode("tr", null, [
                                                    _cache[10] || (_cache[10] = _createElementVNode("th", null, "ポストダイヤル番号", -1)),
                                                    _createElementVNode("td", null, _toDisplayString(_ctx.nyukyo.postDialNo), 1)
                                                ])
                                            ])
                                        ]))
                                        : _createCommentVNode("", true),
                                    _cache[15] || (_cache[15] = _createElementVNode("div", { class: "table-caption" }, "初回引落（集金代行会社・保証会社への手続き状況により振込でのお支払い、および再度、口座振替手続きしていただく場合があります。）", -1)),
                                    _createElementVNode("table", _hoisted_13, [
                                        _createElementVNode("tbody", null, [
                                            _createElementVNode("tr", null, [
                                                _cache[11] || (_cache[11] = _createElementVNode("th", null, "初回引落予定日", -1)),
                                                _createElementVNode("td", null, _toDisplayString(_ctx.nyukyo.shokaiHikiotoshibi), 1)
                                            ])
                                        ])
                                    ]),
                                    _cache[16] || (_cache[16] = _createElementVNode("div", { class: "table-caption" }, "入居者様へのご案内", -1)),
                                    _createElementVNode("table", _hoisted_14, [
                                        _createElementVNode("tbody", null, [
                                            _createElementVNode("tr", null, [
                                                _cache[12] || (_cache[12] = _createElementVNode("th", null, "共通のお知らせ", -1)),
                                                _createElementVNode("td", null, [
                                                    _createElementVNode("a", {
                                                        href: "#",
                                                        onClick: [
                                                            _cache[0] || (_cache[0] = _withModifiers(
                                                            //@ts-ignore
                                                            (...args) => (_ctx.linkClick && _ctx.linkClick(...args)), ["prevent", "stop"])),
                                                            _cache[1] || (_cache[1] = ($event) => (_ctx.downloadFileByCode(_ctx.commonFileCode)))
                                                        ]
                                                    }, "入居者専用ガイド.pdf")
                                                ])
                                            ]),
                                            (_ctx.propertyFileExists)
                                                ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [
                                                    _cache[13] || (_cache[13] = _createElementVNode("th", null, "ご契約物件に関する情報", -1)),
                                                    _createElementVNode("td", null, [
                                                        _createElementVNode("a", {
                                                            href: "#",
                                                            onClick: [
                                                                _cache[2] || (_cache[2] = _withModifiers(
                                                                //@ts-ignore
                                                                (...args) => (_ctx.linkClick && _ctx.linkClick(...args)), ["prevent", "stop"])),
                                                                _cache[3] || (_cache[3] = ($event) => (_ctx.downloadFileByCode(_ctx.propertyFileCode)))
                                                            ]
                                                        }, "お住まいの物件に関するご案内.pdf")
                                                    ])
                                                ]))
                                                : _createCommentVNode("", true),
                                            (_ctx.setFileExists)
                                                ? (_openBlock(), _createElementBlock("tr", _hoisted_16, [
                                                    _cache[14] || (_cache[14] = _createElementVNode("th", null, "入居者セット", -1)),
                                                    _createElementVNode("td", null, [
                                                        _createElementVNode("a", {
                                                            href: "#",
                                                            onClick: [
                                                                _cache[4] || (_cache[4] = _withModifiers(
                                                                //@ts-ignore
                                                                (...args) => (_ctx.linkClick && _ctx.linkClick(...args)), ["prevent", "stop"])),
                                                                _cache[5] || (_cache[5] = ($event) => (_ctx.downloadFileByCode(_ctx.setFileCode)))
                                                            ]
                                                        }, "入居者セット.pdf")
                                                    ])
                                                ]))
                                                : _createCommentVNode("", true)
                                        ])
                                    ])
                                ])
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_q_card_actions, {
                            class: "q-pb-lg",
                            align: "center"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_q_btn, {
                                    class: "btn-route col-8 col-md-4",
                                    label: "トップに戻る",
                                    color: "grey-8",
                                    icon: "navigate_before",
                                    onClick: _cache[6] || (_cache[6] = ($event) => (_ctx.$router.push({ name: 'top' })))
                                })
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                })
            ])
        ]),
        _: 1
    }));
}
